import { Button, ButtonGroup, Text } from '@chakra-ui/react';
import { memo } from 'react';

export type Person = 'buyer' | 'cobuyer';

type Props = {
  activePerson: Person;
  setSelectedPerson: (person: Person) => void;
  buyerName: string;
  cobuyerName: string;
};

const PersonToggle = ({ activePerson, setSelectedPerson, buyerName, cobuyerName }: Props) => {
  return (
    <ButtonGroup
      isAttached
      mx={2}
      mb={2}
      bg="white"
      borderRadius="12px"
      border="1px solid"
      borderColor="gray.200"
      p="2px"
    >
      {(['buyer', 'cobuyer'] as const).map((person) => {
        const active = activePerson === person;
        return (
          <Button
            key={person}
            variant="unstyled"
            flex="1"
            minW={0}
            height="auto"
            py={2}
            px={3}
            borderRadius="10px"
            bg={active ? 'leaseEndBlue' : 'transparent'}
            color={active ? 'white' : 'gray.500'}
            onClick={() => setSelectedPerson(person)}
            aria-pressed={active}
          >
            <Text fontSize="sm" fontWeight="bold" letterSpacing="wide" noOfLines={1}>
              {person === 'buyer' ? buyerName : cobuyerName}
            </Text>
            <Text fontSize="xs" opacity={active ? 0.9 : 0.7}>
              {person === 'buyer' ? 'Buyer' : 'Co-Buyer'}
            </Text>
          </Button>
        );
      })}
    </ButtonGroup>
  );
};

export default memo(PersonToggle);
